import React from 'react';
import Box from "@mui/material/Box";
import "./CustomerReviewContainer.css"
import {HorizontalLinePrimary} from "../Components/HorizontalLine/HorizontalLinePrimary";
import "../../Common.css"
import {useMediaQuery, useTheme} from "@mui/material";

function CustomerReviewContainer(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    let getImageBox = () => {
        if (props.before != null) {
            return (<Box className={" customer_content_container customer_images flex_images"}>
                <Box className={"flexColumnCenter image_with_text_box"}>
                    <Box className={"customer_image_container"}>
                        <img style={{width: "100%"}} src={props.before} alt={"Before"}/>
                    </Box>
                    {isMobile ? (<></>) : (<p className={"customer_subtitle_images_text"}>Before</p>)}

                </Box>
                <Box className={"flexColumnCenter image_with_text_box"}>
                    <Box className={"customer_image_container"}>
                        <img style={{width: "100%"}} src={props.after} alt={"After"}/>
                    </Box>
                    {isMobile ? (<></>) : (<p className={"customer_subtitle_images_text"}>After</p>)}

                </Box>
            </Box>)
        }

    }


    let getCustomerInverseWidth = () => {
        if (props.before == null) {
            return "full_width"
        } else {
            return "half_width"
        }
    }

    return (
        <div className={"full_width customer_container"}>
            <Box className={"customer_box full_width"} sx={{boxShadow: 2}}>
                {getImageBox()}
                <Box className={" customer_content_container customer_text " + getCustomerInverseWidth()}>
                    <p className={"customer_text_title"} sx={{marginBottom: "16px"}}>{props.title}</p>
                    {
                        props.subtitle.map((value, index) =>
                            (<p key={index} className={"customer_text_subtitle"}>
                                {value}
                            </p>)
                        )}
                    <HorizontalLinePrimary/>
                    <p className={"customer_text_content"}>{props.description}</p>
                </Box>
            </Box>
        </div>

    );
}

export default CustomerReviewContainer;